import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = { class: "employees__name" }
const _hoisted_3 = {
  key: 0,
  class: "employees__external-icon",
  title: "Сотрудник не из вашей аптеки"
}
const _hoisted_4 = {
  key: 1,
  class: "employees__external-icon",
  title: "ПСТ"
}
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "employees__info" }
const _hoisted_7 = ["title"]
const _hoisted_8 = { class: "employees__number" }

import VitaIcon from '@/components/UI/VitaIcon.vue';
import VitaButton from '@/components/UI/VitaButton.vue';
import VitaModal from '@/components/UI/VitaModal.vue';
import { checkUnsavedChanges, clearNull, formatPhoneNumber } from '@/utils/main';
import store from '@/store';
import { computed, ref } from 'vue';
import { reachGoal } from '@/utils/metrika';

interface Props {
  name?: string
  position?: string
  number?: number
  newUser: boolean
  zupGuid: string
  external: boolean
  pstUser: boolean
  phone: string | null
  dateEmployment: string | null
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VitaEmployee',
  props: {
    name: {},
    position: {},
    number: {},
    newUser: { type: Boolean },
    zupGuid: {},
    external: { type: Boolean },
    pstUser: { type: Boolean },
    phone: {},
    dateEmployment: {}
  },
  setup(__props: any) {

const props = __props
const openModal = ref<boolean>(false)
const modalTitle = ref<string>('Вы уверены, что хотите удалить сотрудника?')

const deleteNewUser = (zupGuid: string) => {
  store.commit('data/deleteUser', zupGuid)
  checkUnsavedChanges()
  reachGoal('timetable-employee-delete-confirm')
}

const isWFMReaderRole = computed<boolean>(() => {
  return store.getters['getWFMReaderRole']
})

// Проверка даты трудоустройства сотрудника
const isInactive = computed<boolean>(() => {
  const now = new Date()
  
  // Если дата найма в будущем - сотрудник ещё не трудоустроен
  if (props.dateEmployment && new Date(props.dateEmployment) > now) return true
  return false
})

const onUserDeleteClick = () => {
  openModal.value = true
  reachGoal('timetable-employee-delete-click')
}

const onUserDeleteCancel = () => {
  openModal.value = false
  reachGoal('timetable-employee-delete-cancel')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["employees", {'is-inactive': isInactive.value}])
  }, [
    (__props.newUser)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "btn-delete",
          type: "button",
          onClick: onUserDeleteClick,
          title: "Удалить этого сотрудника",
          "data-qa": "employee-button-delete"
        }, [
          _createVNode(VitaIcon, { name: "cross-dark" })
        ]))
      : _createCommentVNode("", true),
    (isWFMReaderRole.value && __props.phone)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: "btn-phone",
          title: _unref(formatPhoneNumber)(__props.phone)
        }, [
          _createVNode(VitaIcon, { name: "phone" })
        ], 8, _hoisted_1))
      : _createCommentVNode("", true),
    (openModal.value)
      ? (_openBlock(), _createBlock(VitaModal, {
          key: 2,
          title: modalTitle.value
        }, {
          default: _withCtx(() => [
            _createVNode(VitaButton, {
              color: "red",
              width: "inline",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (deleteNewUser(__props.zupGuid))),
              "data-qa": "employee-button-delete-confirm"
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("Да", -1)
              ]))]),
              _: 1
            }),
            _createVNode(VitaButton, {
              color: "blue",
              width: "inline",
              onClick: onUserDeleteCancel,
              "data-qa": "employee-button-delete-cancel"
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("Нет", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (__props.external)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(VitaIcon, { name: "external-user" })
          ]))
        : _createCommentVNode("", true),
      (__props.pstUser && !__props.external)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(VitaIcon, {
              class: "-icon",
              name: "profi-user"
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("h4", {
        title: _unref(clearNull)(__props.name)
      }, _toDisplayString(_unref(clearNull)(__props.name)), 9, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        class: "employees__position",
        title: __props.position
      }, _toDisplayString(__props.position), 9, _hoisted_7),
      _createElementVNode("div", _hoisted_8, "(" + _toDisplayString(__props.number) + ")", 1)
    ])
  ], 2))
}
}

})